<div class="space-y-2 xl:space-y-0 p-1 sm:p-0 xl:w-[500px]">
  <p-inputgroup class="w-full h-[40px]">
    <input pInputText
            [(ngModel)]="searchQuery"
            placeholder="Item Number or Name"
            class="pl-3 flex-grow focus:outline-none h-full font-mulish border-2 border-[var(--p-primary-500)] rounded-l-lg box-border"
            (keypress.enter)="doSearch()" />
    <p-button (click)="doSearch()"
            label="Search"
            styleClass="h-full !font-mulish border-2 border-[var(--p-primary-500)] rounded-r-lg !text-[var(--p-text-color-primary)]"
            [style]="{'background-color': 'var(--p-primary-500)', 'border-color': 'var(--p-primary-500)'}">
      <ng-template #icon>
        <fa-icon [icon]="icons.faSearch"></fa-icon>
      </ng-template>
    </p-button>
  </p-inputgroup>
</div>